import { useSite } from "../../context/SiteContext";
import { Reveal, Overline } from "../Reveal";
import { PlusButton } from "../PlusButton";
import HeroMedia, { mediaKind } from "../HeroMedia";

export default function Partnership() {
    const { site, tx } = useSite();
    const partner = (site?.partners || [])[0];
    if (!partner) return null;

    const kind = mediaKind(partner.video_url || "");
    const showEmbed = kind === "youtube" || kind === "vimeo";

    return (
        <section id="partnership" data-testid="partnership-section" className="grain relative overflow-hidden bg-[#0A0A0A] px-6 py-32 text-white md:px-12 md:py-48 lg:px-24">
            <div className="grid items-center gap-16 md:grid-cols-12">
                <div className="md:col-span-6">
                    <Overline testId="partnership-overline">{tx({ en: "IN PARTNERSHIP+", pt: "EM PARCERIA+" })}</Overline>
                    <Reveal>
                        <h2 className="font-display mt-6 text-[clamp(4rem,11vw,10rem)] leading-[0.85]" data-testid="partnership-name">
                            {(partner.name || "").toUpperCase()}
                            <span className="text-[#D60024]">+</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-10 max-w-lg text-base leading-relaxed text-white/70" data-testid="partnership-description">
                            {tx(partner.description)}
                        </p>
                    </Reveal>
                    {partner.url && (
                        <Reveal delay={0.25}>
                            <div className="mt-10">
                                <PlusButton href={partner.url} label={tx({ en: "VISIT", pt: "VISITAR" }) + " " + (partner.name || "").toUpperCase()} testId="partnership-link" />
                            </div>
                        </Reveal>
                    )}
                </div>
                <div className="md:col-span-6">
                    <Reveal delay={0.1}>
                        <div className="relative aspect-video overflow-hidden border border-white/10" data-testid="partnership-media">
                            {showEmbed ? (
                                <HeroMedia url={partner.video_url} poster={partner.image_url} autoplay={false} className="absolute inset-0 h-full w-full object-cover" />
                            ) : partner.image_url ? (
                                <img src={partner.image_url} alt={partner.name} loading="lazy" className="h-full w-full object-cover grayscale" />
                            ) : null}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
